import { Box } from 'ui/box';

import MonitoringContext from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/context-data-panel/monitoring-context';
import ReportContext from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/context-data-panel/report-context';

import type { ContextMetadata } from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/context-data-panel/monitoring-context';
import type { InsightDto } from 'api/generated/schemas/insightDto';
import type { UserInsightDto } from 'api/generated/schemas/userInsightDto';

type PdfContextDataInsight = InsightDto | UserInsightDto;

interface PdfContextDataProps {
  insight: PdfContextDataInsight | null | undefined;
  showViewReport?: boolean;
}

const PdfContextData = ({
  insight,
  showViewReport = false,
}: PdfContextDataProps): React.JSX.Element => {
  const metadata = (insight?.metadata || {}) as ContextMetadata;
  const isReport = metadata?.insightType === 'report';

  return (
    <Box
      sx={{
        borderWidth: '1px',
        borderColor: 'tokens.gray.200',
        borderRadius: '0.5rem',
        bgcolor: 'common.white',
        p: 2,
      }}
    >
      <h2 className="font-semibold text-navy-800 text-lg mb-4">
        Context and data
      </h2>

      <Box>
        {isReport ? (
          <ReportContext
            metadata={metadata}
            clientId={insight?.clientId}
            sourceId={metadata?.sourceId}
            showViewReport={showViewReport}
          />
        ) : (
          <MonitoringContext metadata={metadata} />
        )}
      </Box>
    </Box>
  );
};

export default PdfContextData;
